import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation


const useClickOutsideRef = (elContainer: any, initialVal: boolean, allowedElements?: any[], isMobile?: boolean, closeElementRef?: any) => {
    const [isOpen, setIsOpen] = useState(initialVal);

    const location = useLocation();

    useEffect(() => {
        if (!initialVal) {
            setIsOpen(false);
        }
    }, [initialVal])

    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname, location.search])

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (elContainer.current && !elContainer.current.contains(event.target as Node) && ((allowedElements && allowedElements.length) ? !allowedElements.includes((event.target as Element).className) : true)
            && !isMobile) {
                setIsOpen(false);
            }
        };
    
        const handleBlurOutside = () => {
            if (!isMobile) {
                setIsOpen(false);
            }
        };
    
        const handleOpen = (event: MouseEvent) => {
            setIsOpen(state => {
                if (state && (closeElementRef ? closeElementRef.current.contains(event.target as Node) : false)) {
                    return false
                } else {
                    return true;
                }
            });
        }
        
        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('blur', handleBlurOutside);

        if (elContainer.current) {
            elContainer.current.addEventListener("click", handleOpen)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('blur', handleBlurOutside);
            if (elContainer.current) {
                elContainer.current.removeEventListener("click", handleOpen)
            }
        };
    }, [elContainer]);

    return isOpen;
}

export default useClickOutsideRef;